import { useState, useEffect } from "react";
import { getLoggedInUser } from "services/AuthService";
import featureFlagService from "services/feature-flags";

export function useFeatureFlag(flagName, defaultValue = false) {
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(defaultValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Flag to prevent state updates on unmounted component

    const getFlagStatus = async () => {
      try {
        const value = await featureFlagService.isFeatureEnabled(
          flagName,
          defaultValue
        );

        if (isMounted) {
          setIsFeatureEnabled(value);
        }
      } catch (error) {
        console.error("Failed to fetch feature flag:", error);
        if (isMounted) {
          setIsFeatureEnabled(false); // Default to false on error
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getFlagStatus();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [flagName, defaultValue]);

  return [isFeatureEnabled, loading];
};
